import { render, staticRenderFns } from "./DetailCountry.vue?vue&type=template&id=2e5d9da0&scoped=true&"
import script from "./DetailCountry.vue?vue&type=script&lang=js&"
export * from "./DetailCountry.vue?vue&type=script&lang=js&"
import style0 from "./DetailCountry.vue?vue&type=style&index=0&id=2e5d9da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d9da0",
  null
  
)

export default component.exports